(() => {
  const selector = '[data-rental-calculator]';

  const initCalculator = (root) => {
    if (root.dataset.rentalCalculatorInitialized === 'true') return;

    const amountInput = root.querySelector('[data-calculator-value]');
    const productSelect = root.querySelector('[data-calculator-product]');
    const output = root.querySelector('[data-calculator-output]');

    if (!amountInput || !productSelect || !output) return;

    root.dataset.rentalCalculatorInitialized = 'true';

    const currencyFormatter = (() => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
          style: 'currency',
          currency: root.dataset.currencyCode || 'AUD',
          maximumFractionDigits: 0
        });
      } catch (error) {
        return null;
      }
    })();

    const updateCalculator = () => {
      const amount = Math.max(0, Number(amountInput.value) || 0);
      const selectedProduct = productSelect.selectedOptions[0];
      const monthlyRatePercent = Number(selectedProduct?.dataset.monthlyRate) || 0;
      const fortnightlyEstimate = amount * (monthlyRatePercent / 100) * 12 / 26;
      const weeklyEstimate = Math.round(fortnightlyEstimate / 2);

      output.textContent = currencyFormatter
        ? currencyFormatter.format(weeklyEstimate)
        : `$${weeklyEstimate.toLocaleString()}`;
    };

    [amountInput, productSelect].forEach((control) => {
      control.addEventListener('input', updateCalculator);
      control.addEventListener('change', updateCalculator);
    });

    updateCalculator();
  };

  const initAll = (scope = document) => {
    if (scope instanceof Element && scope.matches(selector)) {
      initCalculator(scope);
      return;
    }

    scope.querySelectorAll(selector).forEach(initCalculator);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
